// extracted by mini-css-extract-plugin
export var validUntil = "CruiseFares-module--valid-until--d76f6";